import { FormattedMessage } from 'react-intl';
import { EasyClaimAppState, EasyClaimFrontendStep } from 'src/easyclaim.api.client.typescript/src';

import styles from './UpdatedProgressBar.module.css';

interface UpdatedProgressBarProps {
	screen: EasyClaimAppState | undefined;
	frontendSteps?: EasyClaimFrontendStep[] | null;
}

const EXCLUDED_STATES: EasyClaimAppState[] = [
	EasyClaimAppState.Onboarding,
	EasyClaimAppState.OnboardingStart,
	EasyClaimAppState.Finished,
	EasyClaimAppState.ThankYou,
	EasyClaimAppState.WaitForAudit,
];

const LAST_STATES: EasyClaimAppState[] = [EasyClaimAppState.Review, EasyClaimAppState.ReviewMapfre];

export const UpdatedProgressBar = ({ screen, frontendSteps }: UpdatedProgressBarProps) => {
	if (!screen || !frontendSteps?.length) return null;
	if (EXCLUDED_STATES.includes(screen)) return null;

	const withoutOnboarding = frontendSteps.filter(
		(s) => !EXCLUDED_STATES.includes(s.appState as EasyClaimAppState)
	);
	const lastReviewIndex = withoutOnboarding.reduce(
		(acc, s, i) => (LAST_STATES.includes(s.appState as EasyClaimAppState) ? i : acc),
		-1
	);
	const filteredSteps =
		lastReviewIndex >= 0 ? withoutOnboarding.slice(0, lastReviewIndex + 1) : withoutOnboarding;

	const currentIndex = filteredSteps.findIndex((s) => s.appState === screen);

	if (currentIndex < 0) return null;

	const current = currentIndex + 1;
	const total = filteredSteps.length;

	const mappedTitle = `${screen.charAt(0).toLowerCase() + screen.slice(1)}.title`;

	return (
		<div className={styles.progressBar}>
			<h2 className={styles.title}>
				<FormattedMessage id={mappedTitle} />
			</h2>
			<div className={styles.barWrapper}>
				<progress className={styles.bar} value={current} max={total} />
				<span className={styles.counter}>
					{current} / {total}
				</span>
			</div>
		</div>
	);
};
